import React from 'react';
import { Clock, Shield, Activity, Users } from 'lucide-react';
const bonuses = [{
  title: 'Clinical Quick Reference Guide™',
  description: 'Instant access to clinical references, assessment reminders, rehabilitation frameworks, and treatment planning tools for faster, more organized clinical work.'
}, {
  title: 'Home Exercise Builder™',
  description: 'Create organized home exercise programs using adaptable templates, planners, exercise resources, and patient instruction materials.'
}, {
  title: 'Patient Progress Dashboard™',
  description: 'Track goals, milestones, reassessments, recovery timelines, and patient progress with professional monitoring tools.'
}, {
  title: 'Clinic Productivity Planner™',
  description: 'Organize your schedule, patient caseload, appointments, follow-ups, and daily workflow with practical clinic management resources.'
}, {
  title: 'Clinical Communication Toolkit™',
  description: 'Improve patient communication with ready-to-use consultation guides, educational resources, follow-up templates, and engagement tools.'
}];
const benefits = [{
  icon: <Clock className="w-6 h-6 text-brand-navy" data-id="element-16" data-mp="2jhwbc7t83qbq" />,
  title: 'Save Hours Every Week',
  desc: 'Stop creating treatment plans, documentation, and patient resources from scratch. Open the system, choose the right framework, and start treating your patients with confidence.'
}, {
  icon: <Shield className="w-6 h-6 text-brand-navy" data-id="element-17" data-mp="1qvlen88qm9k7" />,
  title: 'Greater Clinical Confidence',
  desc: 'Know exactly how to assess patients, organize rehabilitation plans, document progress, and structure treatments with a complete clinical system behind every decision.'
}, {
  icon: <Activity className="w-6 h-6 text-brand-navy" data-id="element-18" data-mp="25oeuiurx8rpe" />,
  title: 'Better Patient Outcomes',
  desc: 'Deliver structured rehabilitation programs that improve mobility, function, recovery, and long-term patient progress through clear and organized treatment pathways.'
}, {
  icon: <Users className="w-6 h-6 text-brand-navy" data-id="element-19" data-mp="1h1kee21wf0xc" />,
  title: 'Improve Patient Retention',
  desc: 'Keep your patients engaged and motivated with professional treatment plans, measurable progress, and a more organized rehabilitation experience that encourages long-term commitment.'
}];
export function BonusSection() {
  return <>
      <section className="py-10 px-4 sm:px-6 bg-brand-paper" data-id="element-20" data-mp="ycntgose5krs">
        <div className="text-center mb-8" data-id="element-21" data-mp="yat9bcoy1wor">
          <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-4 uppercase leading-tight" data-id="element-22" data-mp="teckshdu1gb5">
            5 PREMIUM BONUSES INCLUDED
          </h2>
          <p className="text-sm sm:text-base font-bold text-brand-navy leading-relaxed max-w-2xl mx-auto" data-id="element-23" data-mp="1772bgz4b39el">
            You'll also receive 5 premium bonuses designed to help you save even
            more time and improve your daily clinical workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-24" data-mp="an32bim33h7f">
          {bonuses.map((bonus, i) => <div key={i} className={`bg-white border-2 border-brand-gold/40 p-6 rounded-xl text-center shadow-sm relative overflow-hidden hover:border-brand-gold transition-colors ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:max-w-md sm:mx-auto' : ''}`} data-id="element-25" data-mp="5a4kp5j8tmkw" data-mpi={i}>
              <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-gold" data-id="element-26" data-mp="j9w6vtjwy99z" />
              <p className="text-[11px] font-black text-brand-gold mb-3 tracking-widest uppercase" data-id="element-27" data-mp="j7t4sb5hkpow">
                🎁 BONUS {i + 1}
              </p>
              <h3 className="text-base font-bold text-brand-navy mb-2 leading-tight uppercase" data-id="element-28" data-mp="9chty3x782mf">
                {bonus.title}
              </h3>
              <p className="text-sm text-brand-ink/70 leading-relaxed" data-id="element-29" data-mp="ecvz9e7f0ygr">
                {bonus.description}
              </p>
            </div>)}
        </div>
      </section>

      <section className="py-14 px-4 sm:px-6 bg-white border-y border-gray-200" data-id="element-30" data-mp="2z2lazicto458">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-navy mb-12 uppercase leading-tight" data-id="element-31" data-mp="3f8yd6jyl9tbe">
          WHAT WILL CHANGE
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-32" data-mp="35htx1gx6g2ez">
          {benefits.map((item, i) => <div key={i} className="bg-brand-paper p-6 rounded-xl shadow-sm flex gap-5 items-start border border-gray-100" data-id="element-33" data-mp="30kblrjvotb3t" data-mpi={i}>
              <div className="bg-white p-3 rounded-lg shadow-sm shrink-0" data-id="element-34" data-mp="3t87homdfmyzj">
                {item.icon}
              </div>
              <div data-id="element-35" data-mp="3o81t5f2glslo">
                <h3 className="text-base font-bold text-brand-navy mb-2 uppercase tracking-tight" data-id="element-36" data-mp="3o79zi9sfa4y1">
                  {item.title}
                </h3>
                <p className="text-brand-ink/70 text-sm leading-relaxed" data-id="element-37" data-mp="2ctfzf2a0383y">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}